<div fxLayout="row wrap">
  <div class="teranet-padding" fxFlex="100">
    <div fxLayout="column" fxLayoutAlign="center center">
      <Teranet-PageTitle [PageTitle]="'Change Password'"></Teranet-PageTitle>
      <form class="login-form" [formGroup]="changePasswordForm" #userFormRef="ngForm" (ngSubmit)="OnSubmit()">
        <div class="form-group-flex-column">
          <mat-label class="required-field-after" i18n="@@passwordchange_lbl_oldpassword">Old Password</mat-label>
          <mat-form-field appearance="outline">
            <input matInput
                   data-lpignore="true"
                   type="password"
                   formControlName="oldpassword"
                   autocomplete="current-password"
                   [(ngModel)]="changePasswordModel.oldPassword"
                   required />
            <mat-hint *ngIf="changePasswordForm.get('oldpassword').value">Enter old password</mat-hint>
            <mat-error *ngIf="changePasswordForm.get('oldpassword').hasError('required')">
              Required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-group-flex-column">
          <mat-label class="required-field-after" i18n="@@passwordchange_lbl_newpassword">New Password</mat-label>
          <mat-form-field appearance="outline">
            <input matInput
                   data-lpignore="true"
                   type="password"
                   formControlName="newpassword"
                   autocomplete="new-password"
                   [(ngModel)]="changePasswordModel.newPassword"
                   required />
            <mat-hint *ngIf="changePasswordForm.get('newpassword').value">Enter New password</mat-hint>
            <mat-error *ngIf="changePasswordForm.get('newpassword').hasError('required')">
              Required
            </mat-error>
            <mat-error *ngIf="changePasswordForm.get('newpassword').hasError('minlength')">
              Password length at least
              {{ changePasswordForm.get('newpassword').errors.minlength.requiredLength }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-group-flex-column">
          <mat-label class="required-field-after" i18n="@@passwordchange_lbl_confirmpassword">Confirm New Password</mat-label>
          <mat-form-field appearance="outline">
            <input matInput
                   data-lpignore="true"
                   type="password"
                   formControlName="confirmpassword"
                   autocomplete="new-password"
                   [(ngModel)]="changePasswordModel.confirmPassword"
                   required />
            <mat-hint *ngIf="changePasswordForm.get('confirmpassword').value">Enter confirm new password</mat-hint>
            <mat-error *ngIf="changePasswordForm.get('confirmpassword').hasError('required')">
              Required
            </mat-error>
            <mat-error *ngIf="changePasswordForm.get('confirmpassword').hasError('mustMatch')">
              The New Password and Confirm Password fields do not match
            </mat-error>
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="end">
          <button mat-raised-button class="plain-button" type="button" (click)="onCancel()">Cancel</button>
          <button mat-raised-button class="theme-button" type="submit" [disabled]="!changePasswordForm.valid" i18n="@@passwordchange_btn_save">Change Password</button>
        </div>
        <div class="form-group-flex-column">
          <div *ngIf="(isError != undefined) && isError" class="alert alert-danger" role="alert">
            <div style="padding-left:inherit;">1 errors were found.</div>
            <div *ngIf="isPasswordWeak" style="padding-left:inherit;"><b>Password</b> must meet the following minimum password strength requirements:</div>
            <ul *ngFor="let item of errorMessage">
              <li>{{item}}</li>
            </ul>
          </div>
        </div>
      </form>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" *ngIf="(isError != undefined) && !isError" class="alert alert-success" role="alert">
      Your password has been changed successfully. You will be redirected to login page. Please login using the new credentials.
    </div>
  </div>
</div>
